var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M9.813-7.156A3.828,3.828,0,0,1,7-6,3.854,3.854,0,0,1,4.172-7.172,3.854,3.854,0,0,1,3-10a3.854,3.854,0,0,1,1.172-2.828A3.854,3.854,0,0,1,7-14a3.854,3.854,0,0,1,2.828,1.172A3.854,3.854,0,0,1,11-10,3.88,3.88,0,0,1,9.813-7.156ZM9.813-5a4.03,4.03,0,0,1,2.953,1.234A4.03,4.03,0,0,1,14-.812V.5a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,12.5,2H1.5A1.447,1.447,0,0,1,.438,1.563,1.447,1.447,0,0,1,0,.5V-.812A4.03,4.03,0,0,1,1.234-3.766,4.03,4.03,0,0,1,4.188-5h.531A5.427,5.427,0,0,0,7-4.5,5.427,5.427,0,0,0,9.281-5Z",
    transform: "translate(0 14)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.02e97225f40ba550eec10ec6dba1af15.svg";
export { ForwardRef as ReactComponent };